var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';


const MediaPropertyIcon = ({ className }) => /*#__PURE__*/
_jsx("svg", {
  className: className || '',
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "3 1 18 22" }, void 0, /*#__PURE__*/

_jsx("g", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }, void 0, /*#__PURE__*/
_jsx("path", { d: "m14.5 2h-8.5a2 2 0 0 0 -2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-12.5z" }), /*#__PURE__*/
_jsx("path", { d: "m14 2v6h6m-10 3 5 3-5 3z" })
)
);


export { MediaPropertyIcon };